import { ProjectReadSchema } from '@lunit-io/ctl-data-server';

import { Modality } from 'src/types/api/data/image';
import { dataApi } from 'src/utils/http';

export const shouldUseV3Api = async (
  projectId?: string,
  modality?: Modality | string
): Promise<boolean> => {
  try {
    if (!projectId || !modality) return false;

    const modalityUpper = (
      typeof modality === 'string' ? modality : (modality as Modality)
    )
      .toString()
      .toUpperCase();

    if (modalityUpper !== Modality.DBT && modalityUpper !== Modality.MMG)
      return false;

    const { data: project } = await dataApi.get<ProjectReadSchema>(
      `/projects/${projectId}/`,
      {
        params: {
          all: true,
          modality: modalityUpper.toLowerCase(),
        },
      }
    );

    return project?.dataSource === 'CASE_CURATOR';
  } catch {
    return false;
  }
};
